import React, { useState, useEffect, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { logout } from '../redux/actions/authActions';

const IdleTimeoutRedirect = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const [showContent, setShowContent] = useState(false);
    // Function to redirect to login page
    const redirectToLogin = useCallback(() => {
        //history.push('/dashboard/login');
        dispatch(logout(history));
    }, [dispatch, history]);

    useEffect(() => {
        let timeoutId;

        // Function to reset idle timer
        const resetIdleTimer = () => {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(redirectToLogin, 10 * 60 * 1000); // 5 minutes
        };

        // Event listeners to reset idle timer on user activity
        const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart'];
        events.forEach((event) => {
            window.addEventListener(event, resetIdleTimer);
        });

        // Initial start of idle timer
        resetIdleTimer();

        // Clearing timer and removing event listeners on component unmount
        return () => {
            clearTimeout(timeoutId);
            events.forEach((event) => {
                window.removeEventListener(event, resetIdleTimer);
            });
        };
    }, [history, redirectToLogin]);

    <div>
        {showContent && (
            <div>
                <p>Idle Timeout Redirect</p>
                {/* Your app content here */}
            </div>
        )}
    </div>
};

export default IdleTimeoutRedirect;
